let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6iZL1")).then(() => parcelRequire('ab4oe'));